<h1>Roll Forward</h1>
<mat-divider></mat-divider>
<p>
    Use this tool BEFORE any changes are made to the scholarships for the next year so a historical record can be kept.
    This tool will copy all selected scholarships over to the current school-year.
    Make any updates needed to the scholarships after the roll forward has been done.
</p>

<div class="w-fit mt-[20px] mx-auto">
    @if (valid === true) {
    <mat-card class="mb-[30px] p-[20px]">
        <div class="flex items-center mb-[10px] text-2xl text-green-500">
            <mat-icon class="mr-[20px]">check_circle</mat-icon>
            <span>Settings are good</span>
        </div>
        <div>Process will move scholarship data from latest active year to: <strong>{{endYear | schoolYear}}</strong></div>
    </mat-card>
    }
    @else {
    <mat-card class="mb-[30px] p-[20px]">
        <div class="flex items-center mb-[10px] text-2xl text-red-500">
            <mat-icon class="mr-[20px]">cancel</mat-icon>
            <span>Settings are invalid</span>
        </div>
        @for (e of error; track e) {
        <div class="mb-[10px]">{{e}}</div>
        }
    </mat-card>
    }

    <div class="flex justify-between mb-[20px]">
        <button mat-raised-button (click)="selectActiveLastYear()">Select All Scholarships Active Last Year</button>
        @if (valid === true) {
        <button mat-flat-button (click)="rollForward()">Roll Forward Selected Scholarships</button>
        }
    </div>

    <h3 class="mr-[20px] inline">Legend:</h3>
    <small>Shows how many of each category are currently selected out of how many total of that category</small>
    <div class="flex items-baseline mb-[20px]">
        <div class="active border border-solid border-black p-[10px] min-w-[105px]">Active Last Year {{selection.selected | selectionCount: 'active'}}/{{activeLastYearCount}}</div>
        <div class="historicallyActive border border-solid border-black p-[10px] min-w-[105px]">Historically Active {{selection.selected | selectionCount: 'historicallyActive'}}/{{historicallyActiveCount}}</div>
        <div class="notActive border border-solid border-black p-[10px] min-w-[105px]">Not Active {{selection.selected | selectionCount: 'notActive'}}/{{notActiveCount}}</div>
        <div class="alreadyRolled border border-solid border-black p-[10px] min-w-[105px]">Already Rolled Forward 0/{{alreadyRolledCount}}</div>
    </div>

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true">
        <ng-container matColumnDef="Select">
            <th mat-header-cell *matHeaderCellDef>Select</th>
            <td mat-cell *matCellDef="let row">
                @if (row.AlreadyRolled === false) {
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="LatestActiveYear">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Latest Active Year</th>
            <td mat-cell *matCellDef="let row">{{row.LatestActiveYear | schoolYear}}</td>
        </ng-container>
        <ng-container matColumnDef="ScholarshipName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Scholarship Name</th>
            <td mat-cell *matCellDef="let row">{{row.ScholarshipName}}</td>
        </ng-container>
        <ng-container matColumnDef="Active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
            <td mat-cell *matCellDef="let row">{{row.Active}}</td>
        </ng-container>
        <ng-container matColumnDef="MasterID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Master ID</th>
            <td mat-cell *matCellDef="let row">{{row.MasterID}}</td>
        </ng-container>
        <ng-container matColumnDef="ScholarshipID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Scholarship ID</th>
            <td mat-cell *matCellDef="let row">{{row.ScholarshipID}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [ngClass]="{ active: row.ActiveLastYear, historicallyActive: row.HistoricallyActive, notActive: row.NotActive }"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-red-500 text-center" colspan="6">No data found</td>
        </tr>
    </table>
</div>